import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import Banner from '../components/Banner'

import superStrongCleanup from '../assets/images/super-strong-cleanup.jpg'
import runningPro from '../assets/images/running-pro-2.jpg'
import bestBiker from '../assets/images/best-biker-2.jpg'
import annaPortrait from '../assets/images/anna-portrait.jpg'
import annaAndEllie from '../assets/images/anna-and-ellie-2.jpg'
import annaIsASunflower from '../assets/images/anna-is-a-sunflower.jpg'

class HomeIndex extends React.Component {
    render() {

        return (
            <Layout>
                <Helmet
                    title="Gatsby Starter - Forty"
                    meta={[
                        { name: 'description', content: 'Sample' },
                        { name: 'keywords', content: 'sample, something' },
                    ]}
                >
                </Helmet>

                <Banner />

                <div id="main">
                    <section id="one" className="tiles">
                        <article style={{backgroundImage: `url(${superStrongCleanup})`}}>
                            <header className="major">
                                <h3>Sign Up!</h3>
                                <p>Visit Power Rowing to sign-up for my classes!</p>
                            </header>
                            <a href="https://www.powerrowing.com/book-now" className="link primary"></a>
                        </article>
                        <article style={{backgroundImage: `url(${runningPro})`}}>
                            <header className="major">
                                <h3>Running!</h3>
                                <p>All of my progression through 5K's, 10K's, and Half-Marathons</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${bestBiker})`}}>
                            <header className="major">
                                <h3>Boston!</h3>
                                <p>All of my favorite corners of Boston</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${annaPortrait})`}}>
                            <header className="major">
                                <h3>Beer!</h3>
                                <p>Me (and my dad's) recommendations for all the amazing breweries that we love</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${annaAndEllie})`}}>
                            <header className="major">
                                <h3>Ellie!</h3>
                                <p>All about my amazing and adorable traveling companion Ellie</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${annaIsASunflower})`}}>
                            <header className="major">
                                <h3>Decoration!</h3>
                                <p>How to convince your boyfriend of your superior interior decorating skills</p>
                            </header>
                            <Link to="/landing" className="link primary"></Link>
                        </article>
                    </section>
                    <section id="two">
                        <div className="inner">
                            <header className="major">
                                <h2>Get in Touch!</h2>
                            </header>
                            <p>Want to join my floor workout classes and move your butt? Join me every week! It's full of exercises that will blast your abs and jokes that will split your sides. I'd love to have you, so don't be afraid to sign-up or reach out to me with questions!</p>
                            <ul className="actions">
                                <li><Link to="/landing" className="button next">Get Started</Link></li>
                            </ul>
                        </div>
                    </section>
                </div>

            </Layout>
        )
    }
}

export default HomeIndex